import { useMutation } from '@tanstack/react-query';

import { TCreatePrototypeDto, useAvApi } from '@app-velocity/av-api-v2';

export const useCreateScenarioMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { prototypes } = useAvApi();

  return useMutation({
    mutationKey: ['create-scenario-mutation'],
    mutationFn: async (body: TCreatePrototypeDto) => {
      if (!workspaceId) return;

      const res = await prototypes.postV2ProjectsPrototypesByProjectId(
        body,
        {
          projectId: workspaceId,
        },
        {
          signal,
        }
      );

      return res.data;
    },
  });
};
